export default __webpack_public_path__ + "static/media/001-robotic arm.76f90cce.svg";